<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 编辑商户
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width:500px">
            <el-form label-width="100px" :model="form" ref="form" :rules="rules">
                <el-form-item label="公司名称:" prop="company_name">
                    <el-input class="w400" v-model="form.company_name" :disabled="auth"></el-input>
                </el-form-item>
                <el-form-item label="账号:" prop="company_account">
                    <el-input class="w400" v-model="form.company_account" :disabled="auth"></el-input>
                </el-form-item>
                <!-- <el-form-item label="微信服务费(%):" prop="distribute" v-if="auth">
                    <el-input class="w400" v-model="form.distribute" :disabled="auth"></el-input>
                </el-form-item>
                <el-form-item label="支付宝服务费(%):" prop="distribute" v-if="auth">
                    <el-input class="w400" v-model="form.trade_distribute" :disabled="auth"></el-input>
                </el-form-item>
                <el-form-item label="云闪付服务费(%):" prop="distribute" v-if="auth">
                    <el-input class="w400" v-model="form.acp_distribute" :disabled="auth"></el-input>
                </el-form-item> -->
                <el-form-item label="密码:" prop="company_password">
                    <el-input class="w400" v-model="form.company_password"></el-input>
                </el-form-item>
                <el-form-item label="商户号:" prop="company_mid">
                    <el-input class="w400" v-model="form.company_mid"></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="addMerchant" type="primary">修改</el-button>
        </div>
    </div>
</template>

<script>
    const validateMoney = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入'))
        } else if (value.indexOf(".") != -1 && value.split('.').length > 2) {
            callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
        } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 2) {
            callback(new Error('请输入正确的小数位数')) //小数点后两位
        } else {
            callback();
        }
    };
    export default {

        name: 'add_merchant',

        data() {
            return {
                auth: sessionStorage.getItem('ms_username') == "admin" ? false : true,
                rules: {
                    company_name: [{
                        required: true,
                        message: '请输入商户名称',
                        trigger: 'change'
                    }, ],
                    company_account: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    }, ],
                    company_password: [{
                            required: true,
                            message: '请输入密码',
                            trigger: 'change'
                        },
                        {
                            min: 6,
                            max: 18,
                            message: '长度在 6 到 18 个字符',
                            trigger: 'blur'
                        }
                    ],
                    company_mid: [{
                        required: true,
                        message: '请输入商户号',
                        trigger: 'blur'
                    }, ],
                    distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    trade_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    acp_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ]
                },
                form: {
                    company_name: '',
                    company_account: '',
                    company_password: '',
                    company_mid: '',
                    distribute: '',
                    acp_distribute:'',
                    trade_distribute:'',
                    auth: 2
                },
                query: {
                    id: sessionStorage.getItem("merchants_id") ? sessionStorage.getItem("merchants_id") : '14',
                    auth: '2',
                    limit: 8,
                    page: 1
                },
                addLoading: false
            };
        },
        created() {
            this.getData()
        },
        mounted(){
            console.log(this.form);
        },
        activated() {
            this.getData()
        },
        methods: {
            getData() {
                let that = this
                let url = that.$apiUrl.merchant.getMerchant
                that.loading = true
                that.$post(url, that.$params(that.query)).then(res => {
                    if (res.data.code == 200) {
                        that.loading = false
                        that.form = res.data.data.list[0]
                    }
                }).catch(error => {
                    that.loading = false
                    this.$message.error(error)
                })
            },
            addMerchant() {
                let that = this
                if (!that.addLoading) {
                    that.$refs['form'].validate((valid) => {
                        if (valid) {
                            that.addLoading = !that.addLoading
                            let url = that.$apiUrl.merchant.upMerchant
                            that.$post(url, that.$params(that.form)).then(res => {
                                that.addLoading = false
                                if (res.data.msg == "修改失败") {
                                    this.$message.error("修改失败")
                                } else if (res.data.msg == "修改成功") {
                                    this.$message.success("修改成功")
                                }
                            }).catch(error => {
                                that.addLoading = false
                                this.$message.error(error)
                            })
                        }
                    })
                }
            },
        }
    };
</script>

<style scoped>
    .w400 {
        width: 400px;
    }
</style>